import { render } from "./ComparisonTableDynamic.vue?vue&type=template&id=09a56160&scoped=true"
import script from "./ComparisonTableDynamic.vue?vue&type=script&lang=js"
export * from "./ComparisonTableDynamic.vue?vue&type=script&lang=js"

import "./ComparisonTableDynamic.vue?vue&type=style&index=0&id=09a56160&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09a56160"]])

export default __exports__